import TableActionsMenu from "@/components/data/table/TableActionsMenu"
import { Button } from "@/components/ui/button"
import { DropdownMenuItem } from "@/components/ui/dropdown-menu"
import useFetchStatic from "@/hooks/useFetchStatic"
import { toast } from "@/lib/toast"
import { store } from "@/stores/stores"
import { useSnapshot } from "valtio"
import { Link, useLocation, useNavigate } from "react-router"
import { CredentialForm } from "./Credential.form"
import { ProgressBarTop } from "@/components/feedback/ProgressBarLoader"
import CredentialRow from "./Credential.row"
import Combobox from "@/components/ui/combobox"
import SearchInput from "@/components/form/SearchInput"
import { startTransition, useState } from "react"
import SearchEmpty from "@/components/data/table/SearchEmpty"
import ErrorPage from "@/components/feedback/ErrorPage"

function Credentials() {
  useFetchStatic(["credential"])
  const snap = useSnapshot(store)
  const location = useLocation()
  const navigate = useNavigate()
  const hash = location.hash
  const [menu, section, id, tab, type] = hash.split("/")
  const [search, setSearch] = useState("")

  const credential = snap.credential.list?.find((credential) => credential.id === id)
  const loading = (id && id !== "create" && !credential) || snap.credential.fetching || !snap.scenario.nodeDefinitions.list.length
  const isFiltering = !!search
  const data = snap.credential.list?.filter((credential) => {
    const credMeta = store.credential.credentialsMeta.record[credential.type]
    return (credential.name + credMeta?.label).toLowerCase().includes(search.toLowerCase())
  })
  const isFilteringNotFound = isFiltering && !data.length

  if (id === "create" && !loading) {
    return (
      <CredentialForm
        currentTab={tab}
        id={id}
        type={type}
        onSuccess={(model) => {
          navigate({
            hash: `settings/credentials`,
          })
          // navigate({
          //   hash: `settings/credentials/${model.id}/connection/${model.type}`,
          // })
          // store.credential.actions.testCredentials(model).then(() => {
          //   navigate({
          //     hash: `settings/credentials/${model.id}/connection/${model.type}`,
          //   })
          // })
        }}
      />
    )
  }

  if (id && credential) {
    return (
      <CredentialForm
        currentTab={tab}
        id={id}
        type={type}
        credential={credential}
        onSuccess={() => {
          navigate({
            hash: `settings/credentials`,
          })
        }}
      />
    )
  }

  return (
    <div className="px-9 py-6 h-full w-full flex flex-col">
      {loading && <ProgressBarTop className="pr-5 -mt-[1px]" />}
      <h1 className="text-xl font-semibold mb-5">Credentials</h1>
      <div className="flex gap-3">
        <SearchInput
          data-autofocus
          placeholder="Search credentials..."
          onChange={(e) => {
            startTransition(() => setSearch(e.target.value))
          }}
          className={"w-full max-w-xs font-medium"}
          wrapperClassName="w-full max-w-xs"
        />
        <Combobox
          options={snap.credential.credentialsMeta.list.map((credential) => ({ label: credential.label, value: credential.type }))}
          onChange={(value) => {
            navigate({
              hash: `settings/credentials/create/connection/${value}`,
            })
          }}
        >
          <Button className="rounded-xl">
            <IconHugeiconsPlusSign className="size-3 [&_path]:stroke-3" />
            Credential
          </Button>
        </Combobox>
      </div>
      {!data.length && !store.credential.fetchedError && (
        <div className="flex-1 fc flex-col">
          {isFiltering && (
            <div className="text-center fc flex-col -mt-4">
              <SearchEmpty className="h-42 w-42" />
              <span className="text-sm">We did not find any records with these filters...</span>
            </div>
          )}
          {!isFiltering && (
            <div className="text-center fc flex-col rounded-xl p-5 h-full -mt-4">
              <SearchEmpty className="h-42 w-42" />
              <span className="text-sm">We did not find any records...</span>
            </div>
          )}
        </div>
      )}
      <div className="flex flex-col gap-1.5 mt-5">
        {store.credential.fetchedError && <ErrorPage />}
        {data.map((credential) => (
          <CredentialRow key={credential.id} credential={credential} type={credential.type} />
        ))}
      </div>
    </div>
  )
}

export default Credentials
